import { PokemonCard, SearchResponse } from '../types';
import { pokemonService, FALLBACK_TICKER_CARDS } from './pokemonService';
import { aiCardService } from './aiCardService';

// Local card database - expanded from pokemon-tcg-data structure
// This can be populated from GitHub repo or built-in
export const LOCAL_CARD_DB: PokemonCard[] = [
  // Base Set
  {
    id: 'base1-1',
    name: 'Alakazam',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '80',
    types: ['Psychic'],
    evolvesFrom: 'Kadabra',
    abilities: [{
      name: 'Damage Swap',
      text: 'As often as you like during your turn (before your attack), you may move 1 damage counter from 1 of your Pokémon to another as long as you don\'t Knock Out that Pokémon. This power can\'t be used if Alakazam is Asleep, Confused, or Paralyzed.',
      type: 'Pokémon Power'
    }],
    attacks: [{
      name: 'Confuse Ray',
      cost: ['Psychic', 'Psychic', 'Psychic'],
      convertedEnergyCost: 3,
      damage: '30',
      text: 'Flip a coin. If heads, the Defending Pokémon is now Confused.'
    }],
    weaknesses: [{ type: 'Psychic', value: '×2' }],
    retreatCost: ['Colorless', 'Colorless', 'Colorless'],
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: {
        symbol: 'https://images.pokemontcg.io/base1/symbol.png',
        logo: 'https://images.pokemontcg.io/base1/logo.png'
      }
    },
    number: '1',
    artist: 'Ken Sugimori',
    rarity: 'Rare Holo',
    flavorText: 'Its brain can outperform a supercomputer. Its intelligence quotient is said to be 5,000.',
    nationalPokedexNumbers: [65],
    images: {
      small: 'https://images.pokemontcg.io/base1/1.png',
      large: 'https://images.pokemontcg.io/base1/1_hires.png'
    },
    tcgplayer: {
      url: 'https://www.tcgplayer.com/product/36342',
      updatedAt: '2024/01/01',
      prices: {
        holofoil: { market: 85.00, low: 60.00, high: 150.00 },
        '1stEditionHolofoil': { market: 450.00, low: 300.00, high: 800.00 }
      }
    }
  },
  {
    id: 'base1-2',
    name: 'Blastoise',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '100',
    types: ['Water'],
    evolvesFrom: 'Wartortle',
    abilities: [{
      name: 'Rain Dance',
      text: 'As often as you like during your turn (before your attack), you may attach 1 Water Energy card to 1 of your Water Pokémon. (This doesn\'t use up your 1 Energy card attachment for the turn.) This power can\'t be used if Blastoise is Asleep, Confused, or Paralyzed.',
      type: 'Pokémon Power'
    }],
    attacks: [{
      name: 'Hydro Pump',
      cost: ['Water', 'Water', 'Water'],
      convertedEnergyCost: 3,
      damage: '40+',
      text: 'Does 40 damage plus 10 more damage for each Water Energy attached to Blastoise but not used to pay for this attack\'s Energy cost. You can\'t add more than 20 damage in this way.'
    }],
    weaknesses: [{ type: 'Lightning', value: '×2' }],
    retreatCost: ['Colorless', 'Colorless', 'Colorless'],
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: {
        symbol: 'https://images.pokemontcg.io/base1/symbol.png',
        logo: 'https://images.pokemontcg.io/base1/logo.png'
      }
    },
    number: '2',
    artist: 'Ken Sugimori',
    rarity: 'Rare Holo',
    flavorText: 'A brutal Pokémon with pressurized water jets on its shell. They are used for high-speed tackles.',
    nationalPokedexNumbers: [9],
    images: {
      small: 'https://images.pokemontcg.io/base1/2.png',
      large: 'https://images.pokemontcg.io/base1/2_hires.png'
    },
    tcgplayer: {
      url: 'https://www.tcgplayer.com/product/36343',
      updatedAt: '2024/01/01',
      prices: {
        holofoil: { market: 120.00, low: 80.00, high: 200.00 },
        '1stEditionHolofoil': { market: 800.00, low: 500.00, high: 1500.00 }
      }
    }
  },
  {
    id: 'base1-4',
    name: 'Charizard',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '120',
    types: ['Fire'],
    evolvesFrom: 'Charmeleon',
    abilities: [{
      name: 'Energy Burn',
      text: 'As often as you like during your turn (before your attack), you may turn all Energy attached to Charizard into Fire Energy for the rest of the turn. This power can\'t be used if Charizard is Asleep, Confused, or Paralyzed.',
      type: 'Pokémon Power'
    }],
    attacks: [{
      name: 'Fire Spin',
      cost: ['Fire', 'Fire', 'Fire', 'Fire'],
      convertedEnergyCost: 4,
      damage: '100',
      text: 'Discard 2 Energy cards attached to Charizard in order to use this attack.'
    }],
    weaknesses: [{ type: 'Water', value: '×2' }],
    resistances: [{ type: 'Fighting', value: '-30' }],
    retreatCost: ['Colorless', 'Colorless', 'Colorless'],
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: {
        symbol: 'https://images.pokemontcg.io/base1/symbol.png',
        logo: 'https://images.pokemontcg.io/base1/logo.png'
      }
    },
    number: '4',
    artist: 'Mitsuhiro Arita',
    rarity: 'Rare Holo',
    flavorText: 'Spits fire that is hot enough to melt boulders. Known to unintentionally cause forest fires.',
    nationalPokedexNumbers: [6],
    images: {
      small: 'https://images.pokemontcg.io/base1/4.png',
      large: 'https://images.pokemontcg.io/base1/4_hires.png'
    },
    tcgplayer: {
      url: 'https://www.tcgplayer.com/product/36344',
      updatedAt: '2024/01/01',
      prices: {
        holofoil: { market: 350.00, low: 200.00, high: 600.00 },
        '1stEditionHolofoil': { market: 3000.00, low: 2000.00, high: 5000.00 }
      }
    }
  },
  {
    id: 'base1-58',
    name: 'Pikachu',
    supertype: 'Pokémon',
    subtypes: ['Basic'],
    hp: '40',
    types: ['Lightning'],
    attacks: [
      {
        name: 'Gnaw',
        cost: ['Colorless'],
        convertedEnergyCost: 1,
        damage: '10',
        text: ''
      },
      {
        name: 'Thunder Jolt',
        cost: ['Lightning', 'Colorless'],
        convertedEnergyCost: 2,
        damage: '30',
        text: 'Flip a coin. If tails, Pikachu does 10 damage to itself.'
      }
    ],
    weaknesses: [{ type: 'Fighting', value: '×2' }],
    retreatCost: ['Colorless'],
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: {
        symbol: 'https://images.pokemontcg.io/base1/symbol.png',
        logo: 'https://images.pokemontcg.io/base1/logo.png'
      }
    },
    number: '58',
    artist: 'Mitsuhiro Arita',
    rarity: 'Common',
    flavorText: 'When several of these Pokémon gather, their electricity can build and cause lightning storms.',
    nationalPokedexNumbers: [25],
    images: {
      small: 'https://images.pokemontcg.io/base1/58.png',
      large: 'https://images.pokemontcg.io/base1/58_hires.png'
    },
    tcgplayer: {
      url: 'https://www.tcgplayer.com/product/36395',
      updatedAt: '2024/01/01',
      prices: {
        normal: { market: 15.00, low: 5.00, high: 30.00 }
      }
    }
  }
];

// Combine with existing fallback cards
const ENHANCED_LOCAL_DB: PokemonCard[] = [
  ...LOCAL_CARD_DB,
  ...(FALLBACK_TICKER_CARDS as PokemonCard[])
];

// Create search index for fast local searching
class CardSearchIndex {
  private cards: PokemonCard[];
  private nameIndex: Map<string, PokemonCard[]>;
  private setIndex: Map<string, PokemonCard[]>;
  private typeIndex: Map<string, PokemonCard[]>;

  constructor(cards: PokemonCard[]) {
    this.cards = cards;
    this.nameIndex = new Map();
    this.setIndex = new Map();
    this.typeIndex = new Map();
    this.buildIndex();
  }

  private buildIndex() {
    for (const card of this.cards) {
      // Index by name
      const nameKey = card.name.toLowerCase();
      if (!this.nameIndex.has(nameKey)) {
        this.nameIndex.set(nameKey, []);
      }
      this.nameIndex.get(nameKey)!.push(card);

      // Index by set
      if (card.set?.name) {
        const setKey = card.set.name.toLowerCase();
        if (!this.setIndex.has(setKey)) {
          this.setIndex.set(setKey, []);
        }
        this.setIndex.get(setKey)!.push(card);
      }

      // Index by type
      if (card.types) {
        for (const type of card.types) {
          const typeKey = type.toLowerCase();
          if (!this.typeIndex.has(typeKey)) {
            this.typeIndex.set(typeKey, []);
          }
          this.typeIndex.get(typeKey)!.push(card);
        }
      }
    }
  }

  search(query: string): PokemonCard[] {
    const q = query.toLowerCase().trim();
    const results = new Set<PokemonCard>();

    // Search by name
    for (const [name, cards] of this.nameIndex) {
      if (name.includes(q) || q.includes(name)) {
        cards.forEach(c => results.add(c));
      }
    }

    // Search by set
    for (const [setName, cards] of this.setIndex) {
      if (setName.includes(q) || q.includes(setName)) {
        cards.forEach(c => results.add(c));
      }
    }

    // Search by type
    for (const [type, cards] of this.typeIndex) {
      if (type.includes(q) || q.includes(type)) {
        cards.forEach(c => results.add(c));
      }
    }

    // Fuzzy search on all cards
    for (const card of this.cards) {
      const searchText = `${card.name} ${card.set?.name || ''} ${card.set?.series || ''} ${card.rarity || ''}`.toLowerCase();
      if (searchText.includes(q)) {
        results.add(card);
      }
    }

    return Array.from(results);
  }

  getAll(): PokemonCard[] {
    return [...this.cards];
  }

  getById(id: string): PokemonCard | undefined {
    return this.cards.find(c => c.id === id);
  }
}

// Initialize search index
const searchIndex = new CardSearchIndex(ENHANCED_LOCAL_DB);

// Hybrid Card Service - combines API, AI, and Local data
export const hybridCardService = {
  /**
   * Smart search that tries API first, falls back to local DB and AI
   */
  async searchCards(query: string = '', page: number = 1, useAI: boolean = true): Promise<SearchResponse & { source: string }> {
    // Try API first
    try {
      const apiResult = await pokemonService.searchCards(query, page);
      if (apiResult.data.length > 0) {
        return {
          ...apiResult,
          source: 'api'
        };
      }
    } catch {
      console.log('[Hybrid Search] API unavailable, using fallback');
    }

    // Try local database
    const localResults = searchIndex.search(query);
    if (localResults.length > 0) {
      return {
        data: localResults,
        page: 1,
        pageSize: 20,
        count: localResults.length,
        totalCount: localResults.length,
        source: 'local'
      };
    }

    // Try AI search if enabled
    if (useAI) {
      try {
        const aiResults = await aiCardService.aiSearchCards(query);
        if (aiResults.cards.length > 0) {
          return {
            data: aiResults.cards as PokemonCard[],
            page: 1,
            pageSize: 20,
            count: aiResults.cards.length,
            totalCount: aiResults.cards.length,
            source: 'ai'
          };
        }
      } catch {
        console.log('[Hybrid Search] AI search failed');
      }
    }

    // Return empty results
    return {
      data: [],
      page: 1,
      pageSize: 20,
      count: 0,
      totalCount: 0,
      source: 'none'
    };
  },

  /**
   * Get card by ID from any available source
   */
  async getCardById(id: string): Promise<PokemonCard | null> {
    // Try API first
    try {
      return await pokemonService.getCardById(id);
    } catch {
      // Fallback to local
    }

    // Try local database
    const localCard = searchIndex.getById(id);
    if (localCard) {
      return localCard;
    }

    return null;
  },

  /**
   * Get trending cards from available sources
   */
  async getTrendingCards(): Promise<PokemonCard[]> {
    // Try API first
    try {
      const apiCards = await pokemonService.getTrendingHighValueCards();
      if (apiCards.length > 0) {
        return apiCards;
      }
    } catch {
      console.log('[Hybrid] API trending failed, using fallback');
    }

    // Return local high-value cards
    return ENHANCED_LOCAL_DB
      .filter(c => c.tcgplayer?.prices?.holofoil?.market || c.tcgplayer?.prices?.normal?.market)
      .sort((a, b) => {
        const priceA = a.tcgplayer?.prices?.holofoil?.market || a.tcgplayer?.prices?.normal?.market || 0;
        const priceB = b.tcgplayer?.prices?.holofoil?.market || b.tcgplayer?.prices?.normal?.market || 0;
        return priceB - priceA;
      })
      .slice(0, 10);
  },

  /**
   * Get all available local cards
   */
  getAllLocalCards(): PokemonCard[] {
    return searchIndex.getAll();
  },

  /**
   * Check which data sources are available
   */
  async checkDataSources(): Promise<{
    api: boolean;
    local: boolean;
    ai: boolean;
    localCardCount: number;
  }> {
    let apiAvailable = false;
    try {
      await pokemonService.searchCards('', 1);
      apiAvailable = true;
    } catch {
      apiAvailable = false;
    }

    return {
      api: apiAvailable,
      local: ENHANCED_LOCAL_DB.length > 0,
      ai: !!process.env.API_KEY,
      localCardCount: ENHANCED_LOCAL_DB.length
    };
  }
};

export { ENHANCED_LOCAL_DB, searchIndex };
